const {
	findArguments,
	makeMathCommandNode,
	makeNonmathCommandNode,
} = require("../util/ParserHelpers");

const makeParser = (overrideType, mathMode) => {
	const argQty = overrideType === "read" ? 2 : 1;
	const makeCommandNode = mathMode
		? makeMathCommandNode
		: makeNonmathCommandNode;

	return function(ps) {
		const args = findArguments(ps, argQty);
		if (!args) {
			return false;
		}
		const psList = overrideType === "read" ? [args[1]] : args;
		const readAloudText = overrideType === "read" ? args[0].getRest() : "";
		return makeCommandNode("readAloudOverride", psList, {
			readAloudText,
		});
	};
};

const readAloudOverrideNode = {
	draw(rc, x, y, node, measure) {
		return rc.drawNode(rc, x, y, node.children[0]);
	},
	measure(rc, fontInfo, props, node) {
		return rc.measureNode(rc, fontInfo, props, node.children[0]);
	},
	readAloud: {special: true},
};

module.exports = {
	parsers: {
		nonmathCommands: {
			noread: makeParser("noread", false),
			read: makeParser("read", false),
		},
		mathCommands: {
			noread: makeParser("noread", true),
			read: makeParser("read", true),
		},
	},
	nodes: {
		readAloudOverride: readAloudOverrideNode,
	},
};
